import React, { createContext, useContext, useState } from "react";

const PageTitleContext = createContext();

export const usePageTitle = () => {
  const context = useContext(PageTitleContext);
  if (!context) {
    throw new Error("usePageTitle must be used within a PageTitleProvider");
  }
  return context;
};

export const PageTitleProvider = ({ children }) => {
  const [pageTitle, setPageTitle] = useState("Project Trak");
  const [pageSubtitle, setPageSubtitle] = useState("");

  const setPageTitleWithLog = (title) => {
    setPageTitle(title);
  };

  return (
    <PageTitleContext.Provider
      value={{
        pageTitle,
        pageSubtitle,
        setPageTitle: setPageTitleWithLog,
        setPageSubtitle,
      }}
    >
      {children}
    </PageTitleContext.Provider>
  );
};
